 document.addEventListener('DOMContentLoaded', function () {
        const items = document.querySelectorAll('.ling_click');
        const wrapper = document.querySelector('.ling_top_item_left');
        const fixedTop = document.querySelector('.ling_fixed_top');
        const topButton = document.querySelector('.ling_top_button');
  
        if (!items.length || !wrapper || !fixedTop) return;
  
        let html = '';
  
        // 默认隐藏
        fixedTop.style.display = 'none';
  
        // 生成导航
        items.forEach((item, index) => {
          const title = item.querySelector('.ling_top_title_click');
  
          if (!title) return;
  
          const text = title.textContent.trim();
   
          html += `
            <div class="ling_top_click_text" data-index="${index}">
              ${text}
            </div>
          `;
        });
  
         wrapper.insertAdjacentHTML('afterbegin', html);
  
        const navItems = wrapper.querySelectorAll('.ling_top_click_text');
  
        // 设置高亮
        function setActive(index) {
          navItems.forEach((nav, i) => {
            nav.classList.remove('item_active');
  
            const hr = nav.querySelector('.ling_top_hr');
            if (hr) hr.remove();
  
            if (i === index) {
              nav.classList.add('item_active');
  
              nav.insertAdjacentHTML(
                'beforeend',
                '<div class="ling_top_hr"></div>'
              );
            }
          });
        }
  
        // 清空高亮
        function clearActive() {
          navItems.forEach(nav => {
            nav.classList.remove('item_active');
  
            const hr = nav.querySelector('.ling_top_hr');
            if (hr) hr.remove();
          });
        }
  
        // 点击导航滚动
        navItems.forEach(nav => {
          nav.addEventListener('click', function () {
            const index = this.dataset.index;
            const target = items[index];
  
            if (!target) return;
  
            const offset = 120;
  
            const top =
              target.getBoundingClientRect().top +
              window.pageYOffset -
              offset;
  
            window.scrollTo({
              top,
              behavior: 'smooth'
            });
          });
        });
  
        // 点击按钮滚动到第一个
        if (topButton) {
          topButton.addEventListener('click', function () {
            const firstItem = items[0];
  
            if (!firstItem) return;
  
            const offset = 120;
  
            const top =
              firstItem.getBoundingClientRect().top +
              window.pageYOffset -
              offset;
  
            window.scrollTo({
              top,
              behavior: 'smooth'
            });
          });
        }
  
        // 滚动监听
        window.addEventListener('scroll', function () {
          if (window.innerWidth <= 768) return;
          const firstItem = items[0];
          const firstRect = firstItem.getBoundingClientRect();
  
          const stickyHeader = document.querySelector('sticky-header');
          const announcementBar = document.querySelector('.announcement-bar.sticky');
  
          // 到达第一个 .ling_click 后显示
          if (firstRect.top <= 0) {
            fixedTop.style.display = 'block';
            if (stickyHeader) {
              stickyHeader.style.display = 'none';
            }
  
            if (announcementBar) {
              announcementBar.style.display = 'none';
            }
          } else {
            fixedTop.style.display = 'none';
             if (stickyHeader) {
              stickyHeader.style.display = 'block';
            }
  
            if (announcementBar) {
              announcementBar.style.display = 'flex';
            }
          }
  
          let activeIndex = -1;
  
          items.forEach((item, index) => {
            const rect = item.getBoundingClientRect();
  
            // section 在可视区域内才激活
            if (rect.top <= 150 && rect.bottom >= 150) {
              activeIndex = index;
            }
          });
  
          if (activeIndex !== -1) {
            setActive(activeIndex);
          } else {
            clearActive();
          }
        });
      

  const detailBtn = document.querySelector('.ling_pc_top_click_detail');
  const reviewBtn = document.querySelector('.ling_pc_top_click_pinglun');

  const mainProduct = document.querySelector('.ling_main_product');
  const reviewSection = document.querySelector('#judgeme_product_reviews');



const stickyHeader = document.querySelector('sticky-header');

const mainProductHeight = mainProduct ? mainProduct.offsetHeight : 0;
const stickyHeaderHeight = stickyHeader ? stickyHeader.offsetHeight : 0;

console.log('mainProduct高度:', mainProductHeight);
console.log('stickyHeader高度:', stickyHeaderHeight);

  // 点击详情
  if (detailBtn && mainProduct) {

    detailBtn.addEventListener('click', function () {

      const offset = 0;

      // 滚动到 ling_main_product 底部
      const top = mainProductHeight +  stickyHeaderHeight + offset;

      window.scrollTo({
        top,
        behavior: 'smooth'
      });

    });

  }

  // 点击评论
  if (reviewBtn && reviewSection) {

    reviewBtn.addEventListener('click', function () {

      const offset = 120;

      const top = reviewSection.getBoundingClientRect().top + window.pageYOffset - offset;

      window.scrollTo({
        top,
        behavior: 'smooth'
      });

    });

  }

  window.addEventListener('scroll', function () {

  const scrollTop = window.pageYOffset;

  const mainTop = mainProductHeight +  stickyHeaderHeight;
  const mainBottom = reviewSection.getBoundingClientRect().top + window.pageYOffset;

  const reviewTop = reviewSection.offsetTop;

  // 先清空
  detailBtn.classList.remove('item_active');
  reviewBtn.classList.remove('item_active');
  const dehr = detailBtn.querySelector('.ling_top_hr');
  if (dehr) dehr.remove();
  const rehr = reviewBtn.querySelector('.ling_top_hr');
  if (rehr) rehr.remove();

  // =========================
  // ② ling_main_product 区间（优先级最高）
  // =========================
  if (scrollTop <= mainTop && scrollTop > mainBottom) {
    // 只要在这个区间 → 全部不高亮
    return;
  }

  // =========================
  // ③ 详情区（main_bottom ~ review_top）
  // =========================
  if (scrollTop >= mainTop && scrollTop < mainBottom) {
    detailBtn.classList.add('item_active');
    detailBtn.insertAdjacentHTML(
      'beforeend',
      '<div class="ling_top_hr"></div>'
    );
    return;
  }

  // =========================
  // ④ 评论区
  // =========================
  if (scrollTop >= mainBottom) {
    reviewBtn.classList.add('item_active');
     reviewBtn.insertAdjacentHTML(
      'beforeend',
      '<div class="ling_top_hr"></div>'
    );
    return;
  }

});

});